import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { AuthRoutingModule, routedComponents } from './authentication-routing.module';
import { CoreService } from '../../core/data-services/core.service';


@NgModule({
  imports: [
    SharedModule,
    AuthRoutingModule
  ],
  declarations: [
    routedComponents,
  ],
  providers: [CoreService]
})
export class AuthenticationModule {
}
